import { useMemo } from 'react';

import useForm from '../utils/useForm';

const usePayoffInvoiceForm = (onSubmit, values, hasLienHolder) => {
  /*  const submitHandler = (formValues, actions) => {
    onSubmit(formValues);
    actions.resetForm();
  }; */

  const fields = useMemo(
    () => [
      {
        title: '',
        isTitleHidden: true,
        fields: [
          {
            title: 'Payoff Date',
            name: 'payoff_date',
            type: 'date',
            required: true,
          },
          {
            title: 'Servicer Payoff Amount',
            name: 'pixel_payoff_amount',
            type: 'currency',
            required: true,
            tooltip: 'The amount received by the servicer towards this payoff.',
            tooltipSize: 'md',
          },
          {
            title: 'Lien Holder Principal Payoff Amount',
            name: 'lien_holder_principal_payoff_amount',
            type: 'currency',
            tooltip: 'The amount sent to the lien holder towards principal.',
            tooltipSize: 'md',
            isHidden: () => !hasLienHolder,
          },
          {
            title: 'Lien Holder Interest Payoff Amount',
            name: 'lien_holder_interest_payoff_amount',
            type: 'currency',
            tooltip: 'The amount sent to the lien holder towards interest.',
            tooltipSize: 'md',
            isHidden: () => !hasLienHolder,
          },
          {
            title: 'Source',
            name: 'source',
            type: 'select',
            options: [
              { label: 'ACH Direct', value: 'ACH direct' },
              { label: 'Check', value: 'Check' },
            ],
            defaultValue: 'ACH direct',
          },
        ],
      },
    ],
    [hasLienHolder]
  );

  return useForm({ fields, onSubmit, values });
};

export default usePayoffInvoiceForm;
